var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import { getApiClient } from "../../services/AxiosClients";
import DateService from "./Shared/Date.service";
// Private statics
// Scoring groups are likely to stay the same.  This is a way to simply cache them.
let scoringGroupPromise = null;
const getScoringGroups = () => FetchService.getSingleResponse("/aviso/advisor/getSuccessScoringGroups");
export default class SuccessScoreService {
    static search(query) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!scoringGroupPromise) {
                scoringGroupPromise = getScoringGroups();
            }
            const groups = yield scoringGroupPromise;
            return groups.filter((group) => group.name && group.name.includes(query));
        });
    }
    static getSuccessScoringGroupsById(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!scoringGroupPromise) {
                scoringGroupPromise = getScoringGroups();
            }
            const groups = yield scoringGroupPromise;
            return groups.filter((group) => ids.includes(group.id));
        });
    }
    static canCurrentUserSeePersistenceRisk() {
        return FetchService.getSingleResponse("/aviso/person/canCurrentUserSeeTermSuccessScore");
    }
    static canCurrentUserSeeCourseRisk() {
        return FetchService.getSingleResponse("/aviso/person/canCurrentUserSeeCourseSuccessScore");
    }
    static getNewsFeedRiskFilters() {
        return FetchService.getSingleResponse("/aviso/advisor/newsfeedRiskFilters");
    }
    // prettier-ignore
    static getMinCourseRiskHistoryForTranscriptAndTerm(transcriptId, academicCalendarId, period, rangeFrom, rangeTo) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield getApiClient().get("/stats/getMinCourseRiskHistoryForTranscriptAndTerm", {
                params: {
                    transcriptId,
                    academicCalendarId,
                    period,
                    rangeFrom,
                    rangeTo,
                },
            });
            // @ts-expect-error - TS7006 - Parameter 'datum' implicitly has an 'any' type.
            return data.map((datum) => (Object.assign(Object.assign({}, datum), { date: DateService.getStartOfDay(DateService.parseDateWithSameTimeInLocalTimezone(datum.date)) })));
        });
    }
    // prettier-ignore
    static getAvgPersistenceRiskHistoryForPersonAndTerms(personId, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield getApiClient().get("/stats/getAvgPersistenceRiskHistoryForPersonAndTerm", {
                params: {
                    personId,
                    academicCalendarId: options === null || options === void 0 ? void 0 : options.academicCalendarId,
                    rangeFrom: options === null || options === void 0 ? void 0 : options.rangeFrom,
                    rangeTo: options === null || options === void 0 ? void 0 : options.rangeTo,
                },
            });
            // @ts-expect-error - TS7006 - Parameter 'datum' implicitly has an 'any' type.
            return data.map((datum) => (Object.assign(Object.assign({}, datum), { academicCalendarStartDate: new Date(datum.academicCalendarStartDate) })));
        });
    }
}
